import React, {useEffect, useMemo} from "react";
import {Dashboard, DashboardComponentState} from "../../pages/dashboard/components/interfaces";
import {useComponentStateCallback} from "../../../hooks/dashboard/useComponentStateCallback";

interface ReportOptions {
    discardEstimates: boolean;

}
interface FailingComponentTestProps  extends Dashboard.DashboardComponentPropsBase<ReportOptions> {
    text: string;
}
export default function FailingComponentTest(props: FailingComponentTestProps){
    const setStatus = useComponentStateCallback(props);

    const savedState = useMemo<Partial<DashboardComponentState>>(() => {
        const random = Math.random();
        const p = props
        if (random > 0.5) {
             return {state: "finished"};
        } else if(random < 0.2) {
            return {state: "error"};
        }
        else {
            return {state: "finished"};
        }
    }, [props]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setStatus(savedState);
        }, Math.random() * 1000 * 5)

        return () => {
            clearTimeout(timeout);
        }
    }, []);

    return <h2 className={`text-center`}>{props.text}</h2>
}